export default __webpack_public_path__ + "static/media/mayaLogo.e551652d.png";